import { render, staticRenderFns } from "./DialogBoardsideType.vue?vue&type=template&id=51691b08&"
import script from "./DialogBoardsideType.vue?vue&type=script&lang=js&"
export * from "./DialogBoardsideType.vue?vue&type=script&lang=js&"
import style0 from "./DialogBoardsideType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports